<template>
<nav id="acp-menu" :lang="app.state.lang" class="  visible_md cute-scroll-bar padding-tb-l" @click="hideMenu_md" >
    <div class="acp-menu-content cute-scroll-bar"    >
    <div class="  top-bar-search row  flex-nowrap align-items-center hidden_ld  padding-lr-m padding-b-m gap-2px" >
                <input class="flex-grow-2" type="text" v-model="searchWhat" @keyup.enter="search" :placeholder="tx.t('Search')">


 <button class="visible_sd " :title="tx.t('Search by') + ' # ' + tx.t('Booking')"
                    @click="search('number')"><span class="ti-search"><span>#</span></span></button>

                <button class="visible_sd " :title="tx.t('Search by') + ' ' + tx.t('Plate')"
                    @click="search('phone')"><span class="fa fa-car"></span></button>


            </div>

        <div    >
            <div class='spacer hidden_sd'></div>
            <button class="section" panel="bookings" @click="expandPanel" id="main-menu-bookings">{{tx.t('booking_s')}} </button>
            <div >
                <router-park to="booking/new" class="success" ><span class="icon fa fa-plus"></span> <span>{{tx.t('New Booking')}}</span>           </router-park>
                <router-park to="booking/list/current" ><span class="icon ti-book"></span> <span>{{tx.t('booking_s')}}</span>           </router-park>
                <router-park to="booking/list/recent" ><span class="icon ti-home"></span> <span>{{tx.t('Recent')}}</span>           </router-park>
                <router-park to="booking/list/inside" ><span class="icon ti-car"></span> <span>{{tx.t('Inside')}}</span>           </router-park>
            </div>
        </div>
       <div   >
            <div class='spacer'></div>
            <button   panel="operations" @click ="expandPanel"    class="section" id="main-menu-operations" ><span>{{tx.t('Operations')}}</span></button>
            <div  class="collapse-content">
                <!-- <div class="section" @click.stop="expandPanel('operations')"></div><div class="section">{{tx.t('Operations')}}</div> -->
                <router-park to="ops/summary" ><span class="icon fa fa-binoculars"></span> <span>{{tx.t('Summary')}}</span>           </router-park>
                <router-park to="ops/ins" ><span class="icon ti-import"></span> <span>{{tx.t('INs')}}</span>           </router-park>
                <router-park to="ops/outs" ><span class="icon ti-export"></span> <span>{{tx.t('OUTs')}}</span>           </router-park>
                <router-park to="ops/labels" ><span class="icon fa fa-tags"></span> <span>{{tx.t('Labels')}}</span>           </router-park>
                <!-- <router-park to="ops/hours" ><span class="icon fa fa-clock-o"></span> <span>{{tx.t('Hours')}}</span>           </router-park> -->
            </div>
        </div>
<!--

        <div class="primary" v-if="auth.hasFeature('admin')">
            <div class='spacer'></div>
            <button class="section"  panel='availability' @click="expandPanel"  id="main-menu-admin">{{tx.t('Availability')}}</button>
            <div class="collapse-content">

                <router-park to="availability/groups" ><span class="icon ti-home"></span> <span>{{tx.t('Availability Group_s')}}</span>           </router-park>
                <router-park to="availability/groups" ><span class="icon ti-home"></span> <span>{{tx.t('Availability Calendar')}}</span>           </router-park>


            </div>
        </div>
 -->

        <div class="primary" v-if="auth.hasFeature('admin')">
            <div class='spacer'></div>
            <button class="section"  panel='billing' @click="expandPanel"  id="main-menu-billing">{{tx.t('Billing')}}</button>
            <div class="collapse-content">
                <router-park to="billing/invoice-list" ><span class="icon fa fa-euro"></span> <span>{{tx.t('Invoice List')}}</span>           </router-park>
                <router-park to="admin/billing-configuration"    ><span class="icon ti-settings"></span> <span>{{tx.t('Configuration')}}</span>           </router-park>
                <router-park to="admin/billing-invoice-template"    ><span class="icon ti-ruler-pencil"></span> <span>{{tx.t('Invoice Template_s')}}</span>           </router-park>


            </div>
        </div>
        <div class="primary" v-if="auth.hasFeature('admin')">
            <div class='spacer'></div>
            <button class="section"  panel='clients' @click="expandPanel"  id="main-menu-clients">{{tx.t('Clients')}}</button>
            <div class="collapse-content">
                <router-park to="clients/client-list" ><span class="icon fa fa-user"></span> <span>{{tx.t('Clients List')}}</span>           </router-park>
                <router-park to="clients/new" ><span class="icon fa fa-user"></span> <span>{{tx.t('New Client')}}</span>           </router-park>
            </div>
        </div>
        <div class="primary" v-if="auth.hasFeature('admin')">
            <div class='spacer'></div>
            <button class="section"  panel='coupons' @click="expandPanel"  id="main-menu-coupons">{{tx.t('Coupons')}}</button>
            <div class="collapse-content">
                <router-park to="coupons/coupon-list" ><span class="icon fa fa-euro"></span> <span>{{tx.t('Coupon List')}}</span>           </router-park>
                <router-park to="coupons/new" ><span class="icon fa fa-euro"></span> <span>{{tx.t('New Coupon')}}</span>           </router-park>
            </div>
        </div>
<!--       <div class="primary" v-if="auth.hasFeature('admin')">
            <div class='spacer'></div>
            <button class="section"  panel='coupons for client' @click="expandPanel"  id="main-menu-couponsclient">{{tx.t('Coupons for clients')}}</button>
            <div class="collapse-content">
                <router-park to="couponsclient/couponclient-list" ><span class="icon fa fa-euro"></span> <span>{{tx.t('Coupon for client List')}}</span>           </router-park>
                <router-park to="couponsclient/new" ><span class="icon fa fa-euro"></span> <span>{{tx.t('New Coupon for client' )}}</span>           </router-park>
            </div>
        </div>-->
        <div class="primary" v-if="auth.hasFeature('admin')">
            <div class='spacer'></div>
            <button class="section"  panel='admin' @click="expandPanel"  id="main-menu-admin">Admin</button>
            <div class="collapse-content">
                <router-park to="admin/parking" ><span class="icon ti-home"></span> <span>{{tx.t('Parking')}}</span>           </router-park>
                <router-park to="admin/tolerance-minutes" ><span class="icon ti-timer"></span> <span>{{tx.t('Tolerance minutes')}}</span>           </router-park>
                <router-park to="admin/automatic-cancellation" ><span class="icon fa fa-ban"></span> <span>{{tx.t('Automatic Cancellation')}}</span>           </router-park>
                <router-park to="admin/user" ><span class="icon fa fa-users"></span> <span>{{tx.t('User_s')}}</span>           </router-park>
                <router-park to="admin/price-calculation" ><span class="icon fa fa-calculator"></span> <span>{{tx.t('Price Calculation')}}</span>           </router-park>
                <router-park to="admin/email-template" ><span class="icon fa fa-envelope-o"></span> <span>{{tx.t('Email Template_s')}}</span>           </router-park>
                <router-park to="admin/email-style"    ><span class="icon fa fa-envelope-o"></span> <span>{{tx.t('Email Style_s')}}</span>           </router-park>
                <router-park to="admin/product" ><span class="icon ti-home"></span> <span>{{tx.t('product_s')}}</span>           </router-park>
                  <router-park to="admin/calendar-config" ><span class="icon ti-home"></span> <span>{{tx.t('Calendar')}}</span>           </router-park>

            </div>
        </div>


        <div class="super" v-if="auth.isSuper()">
        <div class='spacer'></div>
            <button class="section" panel="super" @click="expandPanel"  >Super</button>
            <div class="collapse-content">
                <router-link to="/super/smtp-cfg" ><span class="icon fa fa-envelope-o"></span> <span>SMTP Cfg</span></router-link>
                <router-link to="/tools/tx-entry" ><span class="icon fa fa-language"></span> <span>Tx Entry</span></router-link>
                <router-link to="/super/parkimport" ><span class="icon ti-settings"></span> <span>Import</span></router-link>
                <router-link to="/about" ><span class="icon ti-home"></span> <span>About</span>              </router-link>
                <router-link to="/pruebas" ><span class="icon ti-home"></span> <span>Pruebas</span></router-link>

            </div>
        </div>
    </div>
</nav>
</template>

<script setup>
import auth from '@/app/auth';
import app from '@/app/app';
import tx from '@/app/tx';


import { ref } from 'vue';
import { useRouter } from 'vue-router';


const searchWhat = ref('');
const router = useRouter();
const currentPanel=ref('bookings');
const hideMenu_md = (event) => {
    if (event && event.target.id!="acp-menu") {
        let target =  event.target.closest('.collapse-content a, .collapse-content button');
        if (!target) return;
    }

    document.getElementById("acp-menu").classList.add('visible_md');
}

const search = (mode) => {
    let what = searchWhat.value;
    searchWhat.value = '';
    hideMenu_md(null);
    router.push({ name: 'search', query: { what, mode } });

}

let lastPanelEl = null ;

const expandPanel=( event ) =>{
    let el = event.target.closest('#acp-menu a, #acp-menu button');
    hideCurrentPanel();
    currentPanel.value = el.getAttribute("panel");;
    showPanel(el);
}

const  hideCurrentPanel = () => {
    if (!lastPanelEl) {
        lastPanelEl = getEl(currentPanel.value);
    }

    let content = lastPanelEl.nextElementSibling;
    content.classList.add('collapse-content');
    content.style.maxHeight = "0px";
    lastPanelEl.classList.remove('collapse-open');
}

function showPanel(el) {
    lastPanelEl = el;
    el.classList.add('collapse-open');
    let content = el.nextElementSibling;
    content.style.maxHeight = content.scrollHeight + "px";
}


function getEl(panelName) {
    console.log(panelName);
    console.log(`#acp-menu [panel="${panelName}"]`);
    return document.querySelector(`#acp-menu [panel="${panelName}"]`);
}


</script>